export class PlayerViewOcclusion {

    constructor() {
    }
}